import React, { useState } from "react"
import { Divider, message, Modal, Row, Button, Input, Col } from "antd"
import { isMobile } from "react-device-detect"
import { useHistory } from "react-router-dom"

import usePricingModal from "hooks/pricing/use-pricing-modal"
import PaymentsService from "services/guests/payments.service"

const emailTester = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}/

const courseFeeColumns = {
  xs: { span: 24 },
  sm: { span: 24 },
  md: { span: 8 },
  lg: { span: 8 },
}

const PricingModal = () => {
  const {
    pricingModalVisible,
    setPricingModalVisible,
    pricingModalCourse: course,
  } = usePricingModal()
  const [emailId, setEmailId] = useState("")
  const history = useHistory()

  const fetchOrderId = async (course_fee) => {
    if (emailId === "" || emailId === null || !emailTester.test(emailId)) {
      message.error("Please enter a valid email ID!")
      return
    }

    const response = await PaymentsService.create({
      course_fee_id: parseInt(course_fee.id, 10),
      email: emailId,
    })

    if (!response.order_id) {
      message.error("Some error occured!")
      return
    }
    if (response.errors) {
      message.error(response.data.errors.join(" "))
      return
    }

    console.log(response)
    displayRazorpay(response)
  }

  const displayRazorpay = async ({ order_id }) => {
    console.log(parseInt(course.fee, 10) * 100)
    const options = {
      key: process.env.REACT_APP_RAZORPAY_KEY_ID,
      name: "Learner.in",
      description: `Course: ${course.name}`,
      image: "/logo-inline-colored.png",
      order_id,
      prefill: {
        email: emailId,
      },
      handler: async (razorpay_response) => {
        console.log("Razorpay response", razorpay_response)
        const {
          razorpay_order_id,
          razorpay_payment_id,
          razorpay_signature,
        } = razorpay_response
        const response = await PaymentsService.capture({
          razorpay_order_id,
          razorpay_payment_id,
          razorpay_signature,
        })
        console.log("capture response:", response)
        setPricingModalVisible(false)
        message.success(
          "Subscription successful. Please login/register to access the course",
        )
        if (window.fbq) {
          window.fbq("track", "Purchase", {
            currency: "INR",
            value: Math.round(course.fee * 100) / 100,
          })
        }
        if (window.gtag) {
          window.gtag("event", "conversion", {
            send_to: "AW-993191655/8QCfCL7Sg_YBEOfNy9kD",
            transaction_id: razorpay_payment_id,
          })
        }
        setTimeout(() => {
          history.push("/register")
        }, 3500)
      },
    }
    console.log(options)

    const razorpay = new window.Razorpay(options)
    razorpay.open()
  }

  return (
    <Modal
      visible={pricingModalVisible}
      footer={false}
      width={isMobile ? "90vw" : "65vw"}
      onCancel={() => {
        setPricingModalVisible(false)
      }}
    >
      <div style={{ margin: 20 }}>
        <h1 style={{ textAlign: "center" }}>
          Course:{"  "}
          <span style={{ color: "tomato", fontWeight: "800" }}>
            {course.name}
          </span>
        </h1>

        <div style={{ marginBottom: 20 }}>
          <label
            style={{
              margin: "auto",
              fontWeight: 800,
              fontSize: "large",
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <div style={{ width: "20%", textAlign: "right" }}>Email ID:</div>
              <div style={{ marginLeft: 10, width: "80%" }}>
                <Input
                  type="email"
                  value={emailId}
                  onChange={(e) => {
                    setEmailId(e.target.value)
                  }}
                  placeholder="Please enter your email ID!"
                />
              </div>
            </div>
          </label>
        </div>

        <Row gutter={20} type="flex" justify="space-between">
          {course.course_fees.map((course_fee) => {
            return (
              <Col key={course_fee.id} {...courseFeeColumns}>
                <div className="course-item-card" style={{ width: "100%" }}>
                  <div
                    className="course-info"
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "column",
                      alignItems: "center",
                    }}
                  >
                    <h2 style={{ textAlign: "center" }}>
                      {course_fee.duration_name}
                    </h2>
                    <h3 style={{ textAlign: "center", marginBottom: "20px" }}>
                      &#8377;{course_fee.amount}
                    </h3>
                    <Button
                      type="primary"
                      size="large"
                      style={{
                        whiteSpace: "normal",
                        height: "auto",
                        minHeight: "35px",
                      }}
                      onClick={() => {
                        fetchOrderId(course_fee)
                      }}
                    >
                      Buy
                    </Button>
                  </div>
                </div>
                <Divider />
              </Col>
            )
          })}
        </Row>
      </div>
    </Modal>
  )
}

export default PricingModal
